import React from 'react';
import Styled from 'styled-components';
import {useIntl} from 'react-intl';
import Util from '../../../forecast-app/shared/util/util';
import {trackEvent} from '../../../tracking/amplitude/TrackingV2';
import {getAllocationTotalNew} from '../../scheduling/project_allocation_logic';
import {Checkbox} from '@/web-components';
import {CSS_CONSTANTS} from '../../../css_variables';

const Label = Styled.label`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 12px;
	gap: 8px;
	background-color: ${CSS_CONSTANTS.background_ghost_white};
	border-radius: 4px;
	cursor: pointer;
	font-weight: 400;
	font-size 13px;
	color: #393946;
`;

const RightLabel = Styled.div`
	margin-left: auto;
`;

const Container = Styled.div`
	display: grid;
	row-gap: 3px;
`;

export const AllocationCheckboxList = ({allocations, onChange, selected}) => {
	const intl = useIntl();

	const toggleSelection = allocation => {
		const removeSelection = selected.includes(allocation.id);
		trackEvent('Assign To Modal Allocation Checklist', 'Changed');
		if (removeSelection) {
			onChange(selected.filter(selectedAllocationId => selectedAllocationId !== allocation.id));
		} else {
			onChange([...selected, allocation.id]);
		}
	};

	const prettyDate = date => {
		return intl.formatDate(date, {
			year: '2-digit',
			month: 'numeric',
			day: 'numeric',
		});
	};

	return (
		<Container>
			{allocations.map(allocation => {
				return (
					<Label key={allocation.id} data-cy={allocation.id}>
						<Checkbox
							checked={selected.includes(allocation.id)}
							cy={'allocate-modal-soft'}
							onChange={() => toggleSelection(allocation)}
						/>
						{Util.convertMinutesToFullHour(getAllocationTotalNew(allocation), intl)}
						<RightLabel>{prettyDate(allocation.startDate) + ' - ' + prettyDate(allocation.endDate)}</RightLabel>
					</Label>
				);
			})}
		</Container>
	);
};
